import {
    USER_LOADED,
    LOGOUT,
    GET_2FA_USER_DETAILS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './authTypes'

export default (state, action) => {
    switch (action.type) {
        case USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.data,
                isAdmin:
                    String(action.payload.data?.emp_type || '').indexOf(
                        'admin'
                    ) !== -1,
            }
        case GET_2FA_USER_DETAILS:
            return {
                ...state,
                twoFactor_details: action.payload,
            }
        case LOGOUT:
            localStorage.removeItem('token')
            localStorage.removeItem('oktaToken')
            if (process.env?.REACT_APP_OKTA_SIGNIN === 'true') {
                window.location.href = '/logout'
            }
            return {
                ...state,
                token: null,
                isAdmin: false,
                isAuthenticated: false,
                loading: false,
                user: {},
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
